export default __webpack_public_path__ + "static/14_9-e874a64f822e022687dbeb7778c9e12a.png";